<div *ngIf="user" class="page-wrapper scrollbar" #mainDiv>
  <app-sidebar [isOpened]="isMenuOpened" (menuClosed)="isMenuOpened = false"></app-sidebar>
  <app-header (openSidebarEmitter)="isMenuOpened = $event" [name]="user?.name" [surname]="user?.surname" [email]="user?.email" [phone]="user?.phoneNumber" [id]="user?.id" [profileImageUrl]="userProfileImageUrl"></app-header>
  <div class="page-wrapper">

    <div class="main-content">
      <router-outlet class="row justify-content-center"></router-outlet>
    </div>
  </div>

  @if (isIndividualCardsPage) {
    <div class="common-footer">
      <button class="outlined-button mobile-button tall-button gap-10px" (click)="openCreateCard()">
        <mat-icon>add</mat-icon>
        {{ 'home-page-content.create_new_card' | translate }}
      </button>
    </div>
  }

  @if (isPlanSubscriptionsPage && isActiveCancelButton) {
    <div class="common-footer">
      <button class="outlined-button mobile-button tall-button" (click)="cancelSubscription()">{{ 'Cancel' | translate }}</button>
    </div>
  }

  @if (isSubscriptionPaymentPage) {
    <div class="common-footer">
      <button class="filled-button mobile-button tall-button" (click)="onClickPayNowSubscription()">Pay Now</button>
    </div>
  }
</div>
